<template>
  <MenuPopover
    v-if="!showNothing"
    class="ScopeMenu"
    trigger="click"
    placement="bottom"
    align="start"
    :bound-to="{ x: 'container' }"
    :bound-to-selector="within"
    :offset="{ y: 5 }"
    :trigger-attrs="{ title: $t('post_status.scope_menu') }"
    :items="items"
  >
    <template #trigger>
      <FAIcon
        :icon="icon(currentScope)"
        fixed-width
      />
      <span class="label">{{ $t(`general.scope_in_timeline.${currentScope}`) }}</span>
      <FAIcon
        class="chevron"
        icon="chevron-down"
      />
    </template>
  </MenuPopover>
</template>

<script src="./scope_menu.js"></script>

<style lang="scss">
@use "../../mixins";

.ScopeMenu {
  display: inline-flex;
}

.ScopeMenu > .popover-trigger-button {
  @include mixins.control-pill(
    color-mix(in oklab, var(--link) 55%, transparent),
    var(--link)
  );

  min-width: 0;
  max-width: 100%;

  .label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .chevron {
    font-size: 0.7em;
  }
}

</style>
